module.exports = __webpack_public_path__ + "static/media/cypherpunk.f0ff9cc4.png";